export const MAX_SEAT_COUNT = 9;
